import { fetchAMSRoleList } from 'lib/apis';
import channelService from 'lib/services/channelService';
import { currentUrlParams } from 'lib/utils/url/index';
import { MSDK_SYSTEM } from 'lib/constants/ams';

const MSDK_V3_KEY = 'msdkEncodeParam';
const MSDK_V5_KEY = 'itopencodeparam';

const MSDK_PARAMS_LIST = ['msdkEncodeParam', 'timestamp', 'appid', 'openid', 'algorithm', 'encode', 'sig', 'version', 'channelid', 'os', 'gameid', 'ts', 'itopencodeparam'] as const;

export const enum MSDK_VERSION {
  V5 = 'v5',
  V3 = 'v3',
}

export type MSDK_PARAMS = {
  [K in typeof MSDK_PARAMS_LIST[number]]?: string
};

class MSDKUtil {
  private version?: MSDK_VERSION;
  private MSDKEnv?: boolean;
  private MSDKUrlParams?: MSDK_PARAMS;

  public init() {
    const urlParams = currentUrlParams.getCurrentParams();
    this.MSDKEnv = !!urlParams[MSDK_V3_KEY] || !!urlParams[MSDK_V5_KEY];
    if (!this.MSDKEnv) return;
    this.version = urlParams[MSDK_V3_KEY] ? MSDK_VERSION.V3 : MSDK_VERSION.V5;
    this.MSDKUrlParams = this.getMSDKParams();
  }

  public get MSDKParams() {
    return this.MSDKUrlParams;
  }

  public get MSDKVersion() {
    return this.version;
  }

  public get isMSDK() {
    return this.MSDKEnv;
  }

  // 原来判读是否是MSDK环境的必须得等到init之后才能判断，这个不太合理
  public get isMSDKEnv() {
    const urlParams = currentUrlParams.getCurrentParams();
    return !!urlParams[MSDK_V3_KEY] || !!urlParams[MSDK_V5_KEY];
  }

  public get MSDKSystem() {
    const reg = /platid|os/i;
    return MSDK_SYSTEM[this.getFuzzyMatchingParams(reg)];
  }

  public get MSDKPartition() {
    const reg = /partition/i;
    return this.getFuzzyMatchingParams(reg);
  }

  public get MSDKChannel() {
    const reg = /channel|area/i;
    return this.getFuzzyMatchingParams(reg);
  }

  public async getAMSGameRoleByMSDKParams() {
    if (!this.isMSDK) return;
    const res = await fetchAMSRoleList({
      gameCode: channelService.gameCode,
      amsChannelId: this.MSDKChannel || '',
      // 兼容codm 链接参数会带上partition = 0, 导致会默认带上’0‘，后台接口报错
      amsPartitionId: Number(this.MSDKPartition) ? this.MSDKPartition : '',
      amsSystemId: this.MSDKSystem || '',
    });

    if (res?.code !== 0) return;
    const roleList = res?.data?.map(item => ({
      roleName: item.name,
      roleId: item.id,
    })) || [];
    return {
      ...roleList[0],
      gameCode: channelService.gameCode,
      amsChannelId: this.MSDKChannel,
      amsPartitionId: this.MSDKPartition,
      amsSystemId: this.MSDKSystem,
    };
  }

  private getMSDKParams() {
    const params: MSDK_PARAMS = {};
    for (const key of MSDK_PARAMS_LIST) {
      params[key] = currentUrlParams.getCurrentParams(key);
    }
    return params;
  }

  private getFuzzyMatchingParams(reg: RegExp) {
    const urlParams = currentUrlParams.getCurrentParams();
    const matchKeys = Object.keys(urlParams).filter(c => reg.test(c));
    if (!matchKeys.length) return '';
    return urlParams[matchKeys[0]];
  }
}

const msdkUtil = new MSDKUtil();

export default msdkUtil;
